function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { s as styleInject, P as PropTypes } from '../style-inject.es-3bd340c8.js';
import { u as uuid, c as co } from '../index-65ee9985.js';
import { s as slicedToArray, t as toConsumableArray } from '../_babelHelpers-a63acad8.js';
import { c as classnames } from '../index-bddb7af5.js';
import { u as util_2, a as util_1 } from '../index-989b4d2a.js';
import '../index-bf9f069c.js';
import { C as CRender } from '../index-b7412e2a.js';
var css = ".dv-water-pond-level {\n  position: relative;\n}\n.dv-water-pond-level svg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n}\n.dv-water-pond-level text {\n  font-size: 25px;\n  font-weight: bold;\n  text-anchor: middle;\n  dominant-baseline: middle;\n}\n.dv-water-pond-level ellipse,\n.dv-water-pond-level rect {\n  fill: none;\n  stroke-width: 3;\n}\n.dv-water-pond-level canvas {\n  margin-top: 8px;\n  margin-left: 8px;\n  width: calc(100% - 16px);\n  height: calc(100% - 16px);\n  box-sizing: border-box;\n}\n";
styleInject(css);
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(animationWave);
var defaultConfig = {
  /**
   * @description Data
   * @type {Array<Number>}
   * @default data = []
   * @example data = [60, 40]
   */
  data: [],
  /**
   * @description Shape of wanter level pond
   * @type {String}
   * @default shape = 'rect'
   * @example shape = 'rect' | 'roundRect' | 'round'
   */
  shape: 'rect',
  /**
   * @description Water wave number
   * @type {Number}
   * @default waveNum = 3
   */
  waveNum: 3,
  /**
   * @description Water wave height (px)
   * @type {Number}
   * @default waveHeight = 40
   */
  waveHeight: 40,
  /**
   * @description Wave opacity
   * @type {Number}
   * @default waveOpacity = 0.4
   */
  waveOpacity: 0.4,
  /**
   * @description Colors (hex|rgb|rgba|color keywords)
   * @type {Array<String>}
   * @default colors = ['#00BAFF', '#3DE7C9']
   * @example colors = ['#000', 'rgb(0, 0, 0)', 'rgba(0, 0, 0, 1)', 'red']
   */
  colors: ['#3DE7C9', '#00BAFF'],
  /**
   * @description Formatter
   * @type {String}
   * @default formatter = '{value}%'
   */
  formatter: '{value}%'
};
function drawed(_ref, _ref2) {
  var points = _ref.shape.points;
  var ctx = _ref2.ctx,
    area = _ref2.area;
  var firstPoint = points[0];
  var lastPoint = points.slice(-1)[0];
  var h = area[1];
  ctx.lineTo(lastPoint[0], h);
  ctx.lineTo(firstPoint[0], h);
  ctx.closePath();
  ctx.fill();
}
function mergeOffset(_ref3, _ref4) {
  var _ref6 = slicedToArray(_ref3, 2),
    x = _ref6[0],
    y = _ref6[1];
  var _ref5 = slicedToArray(_ref4, 2),
    ox = _ref5[0],
    oy = _ref5[1];
  return [x + ox, y + oy];
}
function calcSvgBorderGradient(_ref7) {
  var colors = _ref7.colors;
  var colorNum = colors.length;
  var colorOffsetGap = 100 / (colorNum - 1);
  return colors.map(function (c, i) {
    return [colorOffsetGap * i, c];
  });
}
function calcDetails(_ref8) {
  var data = _ref8.data,
    formatter = _ref8.formatter;
  if (!data.length) {
    return '';
  }
  var maxValue = Math.max.apply(Math, toConsumableArray(data));
  return formatter.replace('{value}', maxValue);
}
function getWaveShapes(_ref9, _ref10) {
  var waveNum = _ref9.waveNum,
    waveHeight = _ref9.waveHeight,
    data = _ref9.data;
  var _ref11 = slicedToArray(_ref10, 2),
    w = _ref11[0],
    h = _ref11[1];
  var pointsNum = waveNum * 4 + 4;
  var pointXGap = w / waveNum / 2;
  return data.map(function (v) {
    var points = new Array(pointsNum).fill(0).map(function (foo, j) {
      var x = w - pointXGap * j;
      var startY = (1 - v / 100) * h;
      var y = j % 2 === 0 ? startY : startY - waveHeight;
      return [x, y];
    });
    points = points.map(function (p) {
      return mergeOffset(p, [pointXGap * 2, 0]);
    });
    return {
      points: points
    };
  });
}
function getWaveStyle(_ref12, area) {
  var colors = _ref12.colors,
    waveOpacity = _ref12.waveOpacity;
  return {
    gradientColor: colors,
    gradientType: 'linear',
    gradientParams: [0, 0, 0, area[1]],
    gradientWith: 'fill',
    opacity: waveOpacity,
    translate: [0, 0]
  };
}
function getWave(mergedConfig, renderer) {
  var area = renderer.area;
  var shapes = getWaveShapes(mergedConfig, area);
  var style = getWaveStyle(mergedConfig, area);
  return shapes.map(function (shape) {
    return renderer.add({
      name: 'smoothline',
      animationFrame: 300,
      shape: shape,
      style: style,
      drawed: drawed
    });
  });
}
function animationWave(waves, renderer) {
  return _regeneratorRuntime().wrap(function animationWave$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          waves.forEach(function (graph) {
            graph.attr('style', {
              translate: [0, 0]
            });
            graph.animation('style', {
              translate: [renderer.area[0], 0]
            }, true);
          });
          _context.next = 3;
          return renderer.launchAnimation();
        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
var WaterLevelPond = function WaterLevelPond(_ref13) {
  var _ref13$config = _ref13.config,
    config = _ref13$config === undefined ? {} : _ref13$config,
    className = _ref13.className,
    style = _ref13.style;
  var _useState = useState(null),
    _useState2 = slicedToArray(_useState, 2),
    renderer = _useState2[0],
    setRenderer = _useState2[1];
  var gradientId = useRef('water-level-pond-' + uuid()).current;
  var domRef = useRef(null);
  var mergedConfig = useMemo(function () {
    return util_2(util_1(defaultConfig, true), config);
  }, [config]);
  var svgBorderGradient = useMemo(function () {
    return calcSvgBorderGradient(mergedConfig);
  }, [mergedConfig]);
  var details = useMemo(function () {
    return calcDetails(mergedConfig);
  }, [mergedConfig]);
  var radius = useMemo(function () {
    var shape = mergedConfig.shape;
    if (shape === 'round') return '50%';
    if (shape === 'rect') return '0';
    if (shape === 'roundRect') return '10px';
    return '0';
  }, [mergedConfig]);
  var shape = useMemo(function () {
    var shape = mergedConfig.shape;
    return shape || 'rect';
  }, [mergedConfig]);
  useEffect(function () {
    var _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(loop);
    var innerRenderer = renderer;
    if (!renderer) {
      innerRenderer = new CRender(domRef.current);
      setRenderer(innerRenderer);
    }
    function loop() {
      var wave;
      return _regeneratorRuntime().wrap(function loop$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 30);
              });
            case 2:
              wave = getWave(mergedConfig, innerRenderer);
            case 3:
              return _context2.delegateYield(animationWave(wave, innerRenderer), 't0', 5);
            case 5:
              if (innerRenderer.graphs.length) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt('return');
            case 7:
              _context2.next = 3;
              break;
            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _marked2, this);
    }
    var _co = co(loop),
      end = _co.end;
    return function () {
      innerRenderer.delAllGraph();

      // 处理 renderer.launchAnimation 返回 undefined，导致长时间占用主线程（待 cender 下版本，处理后删除下面代码）
      innerRenderer.graphs.forEach(function (_) {
        return _.pauseAnimation();
      });
      innerRenderer.animationStatus = false;
      end();
    };
  }, [mergedConfig]);
  var classNames = useMemo(function () {
    return classnames('dv-water-pond-level', className);
  }, [className]);
  return React.createElement('div', {
    className: classNames,
    style: style
  }, !!renderer && React.createElement('svg', null, React.createElement('defs', null, React.createElement('linearGradient', {
    id: gradientId,
    x1: '0%',
    y1: '0%',
    x2: '0%',
    y2: '100%'
  }, svgBorderGradient.map(function (lc) {
    return React.createElement('stop', {
      key: lc[0],
      offset: lc[0],
      stopColor: lc[1]
    });
  }))), React.createElement('text', {
    stroke: 'url(#' + gradientId + ')',
    fill: 'url(#' + gradientId + ')',
    x: renderer.area[0] / 2 + 8,
    y: renderer.area[1] / 2 + 8
  }, details), !shape || shape === 'round' ? React.createElement('ellipse', {
    cx: renderer.area[0] / 2 + 8,
    cy: renderer.area[1] / 2 + 8,
    rx: renderer.area[0] / 2 + 5,
    ry: renderer.area[1] / 2 + 5,
    stroke: 'url(#' + gradientId + ')'
  }) : React.createElement('rect', {
    x: '2',
    y: '2',
    rx: shape === 'roundRect' ? 10 : 0,
    ry: shape === 'roundRect' ? 10 : 0,
    width: renderer.area[0] + 12,
    height: renderer.area[1] + 12,
    stroke: 'url(#' + gradientId + ')'
  })), React.createElement('canvas', {
    ref: domRef,
    style: {
      borderRadius: '' + radius
    }
  }));
};
WaterLevelPond.propTypes = {
  config: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.object
};
export default WaterLevelPond;